/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./app.component.sass.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "@angular/router";
import * as i3 from "./app.component";
import * as i4 from "../base-app/shared/services/helpers.service";
import * as i5 from "@angular/service-worker";
import * as i6 from "./shared/services/analytics.service";
var styles_EyrusAppComponent = [i0.styles];
var RenderType_EyrusAppComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_EyrusAppComponent, data: {} });
export { RenderType_EyrusAppComponent as RenderType_EyrusAppComponent };
export function View_EyrusAppComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 16777216, null, null, 1, "router-outlet", [], null, null, null, null, null)), i1.ɵdid(1, 212992, null, 0, i2.RouterOutlet, [i2.ChildrenOutletContexts, i1.ViewContainerRef, i1.ComponentFactoryResolver, [8, null], i1.ChangeDetectorRef], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
export function View_EyrusAppComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-root", [], null, null, null, View_EyrusAppComponent_0, RenderType_EyrusAppComponent)), i1.ɵdid(1, 114688, null, 0, i3.EyrusAppComponent, [i4.HelpersService, i5.SwUpdate, i6.AnalyticsService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var EyrusAppComponentNgFactory = i1.ɵccf("app-root", i3.EyrusAppComponent, View_EyrusAppComponent_Host_0, {}, {}, []);
export { EyrusAppComponentNgFactory as EyrusAppComponentNgFactory };
